import { type IOverviewJointBillService } from "@services/overview/types";

export enum TaxCollectorCategory {
  OnlineBanking = "onlineBanking",
  CreditCard = "creditCard",
  Other = "other",
}

export enum TaxCollectorRequirement {
  MaxPlanRequired = "maxPlanRequired",
}

export enum TaxCollectorTypeId {
  BANK_TRANSFER = "BT",
  NEO_FINANCE = "MIP",
  MAXIMA = "MXM",
  CREDIT_CARD = "PAY",
  PERLAS = "PRL",
  PAYSERA = "PS",
  LIETUVOS_PASTAS = "PST",
  ESTO = "EST",
  TARKPAY = "TRP",
}

export interface ITaxCollectorType {
  taxCollectorTypeId: TaxCollectorTypeId;
  name: string;
  description: string;
  logo?: ILogo;
  isChecked: boolean;
  category: TaxCollectorCategory;
  notMetRequirements: TaxCollectorRequirement[];
}

export interface ILogo {
  fileName: string;
  mimeType: string;
  contentBase64: string;
}

export interface IPaymentTaxCollectorTypes {
  taxCollectorTypes: ITaxCollectorType[];
}

export enum PaymentType {
  ONLINE_PAYMENT = "onlinePayment",
  BANK_TRANSFER = "bankTransfer",
  PAPER_BILL = "paperBill",
  FAKE_PAYMENT = "fakePayment",
}

export interface IPaymentBase {
  paymentOrderInvoiceId: string;
  paymentType: PaymentType;
}

export interface IOnlinePayment extends IPaymentBase {
  paymentOrderInvoiceId: string;
  paymentUrl: string;
  paymentRedirectUrl: string;
  successfulPaymentRedirectUrl: string;
  failedPaymentRedirectUrl: string;
}

export interface IBankTransferPayment extends IPaymentBase {
  receiver: string;
  swiftCode: string;
  amount: number;
  currencyId: string;
  paymentPurpose: string;
  bankAccountNumber: string;
  internetBankLink: string;
}

export interface IPaperBill {
  jointBillServiceId: number;
  address: string;
  fileDownloadLink: string;
}

export interface IPaperBillPayment extends IPaymentBase {
  paperBills: IPaperBill[];
  taxCollectorTypeId: TaxCollectorTypeId;
}

export interface IFakePayment extends IPaymentBase {
  totalAmount: number;
  currencyId: string;
  description: string;
  taxCollectorName: string;
  fakePaymentDetails: IFakePaymentDetail[];
}

export interface IFakePaymentDetail {
  jointBillServiceId: number;
  amount: number;
  period: string;
  jointBillServiceAdress: string;
  expectedPayments: IExpectedPayment[];
}

export interface IExpectedPayment {
  expectedAmount: number;
  displayName: string;
}

export type TPayment =
  | IOnlinePayment
  | IBankTransferPayment
  | IPaymentBase
  | IFakePayment;

export interface IInitiatePaymentRequestParams {
  periodId: number;
  selectedJointBillServiceIds: IOverviewJointBillService["jointBillServiceId"][];
}

export interface IGetJointBillServicesExpectedPaymentAmountRequestParams {
  periodId: number;
  selectedJointBillServiceIds: IOverviewJointBillService["jointBillServiceId"][];
}

export enum PaymentStatus {
  SUCCESS = "success",
  FAILED = "failed",
  PENDING = "pending",
  CANCELLED = "cancelled",
}

export enum BeforePaymentAction {
  FilloutAntiMoneyLaunderingForm = "filloutAntiMoneyLaunderingForm",
  FilloutKycWithAntiMoneyLaunderingForm = "filloutKycWithAntiMoneyLaunderingForm",
  RestrictPayment = "restrictPayment",
}

export enum PaymentRestrictionType {
  NoRestriction = "noRestriction",
  NotFilledKYC = "notFilledKYC",
  DidNotProvideDocuments = "didNotProvideDocuments",
  FilledKycRestrictedPayment = "filledKycRestrictedPayment",
  ExtremeRiskLevel = "extremeRiskLevel",
}
